export default __webpack_public_path__ + "images/btn_google_signin_dark_normal_web@2x.png";